/* eslint-disable prettier/prettier */

import React, { FunctionComponent } from "react";
import EasySoftwareEditorContainer, {
  PuxWysiwygHtmlBodyType,
} from "Root/Shared/components/EasySoftwareEditorContainer/EasySoftwareEditorContainer";
import PuxButton, { PuxButtonType } from "../PuxButton/PuxButton";
import PuxMediaSelector, {
  PuxMediaSelectorType,
} from "Root/Shared/components/content/mediaImage/PuxMediaSelector";

export interface EasySoftwareHeroBannerItemTextType {
  contentItemId: string;
  contentType: string;
  displayText: string;
  heroBannerItemTextContent: PuxWysiwygHtmlBodyType;
  heroBannerItemTextButton1: PuxButtonType;
  heroBannerItemTextButton2: PuxButtonType;
}

export interface EasySoftwareHeroBannerItemTextProps {
  data: EasySoftwareHeroBannerItemTextType;
  pageContentItemId: string
  editorPath: string
}

const EasySoftwareHeroBannerItemText: FunctionComponent<
  EasySoftwareHeroBannerItemTextProps
> = (props) => {
  const primaryButton = props.data.heroBannerItemTextButton1,
    secondaryButton = props.data.heroBannerItemTextButton2,
    hasPrimaryButton = Boolean(primaryButton?.buttonLink.text?.[0]),
    hasSecondaryButton = Boolean(secondaryButton?.buttonLink.text?.[0]);

  return (
    <div className={`HeroBannerItem HeroBannerItem--onlyText `}>
      <div className="HeroBannerItem-text">
        <EasySoftwareEditorContainer pageContentItemId={props.pageContentItemId} content={props.data.heroBannerItemTextContent} editorPath={props.editorPath} wysiwygId={props.data.contentItemId} />
        {(hasPrimaryButton || hasSecondaryButton) && (
          <div className="HeroBannerItem-buttons">
            {hasPrimaryButton && <PuxButton {...primaryButton} />}
            {hasSecondaryButton && <PuxButton {...secondaryButton} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default EasySoftwareHeroBannerItemText;
